import ManageFocus from './services/manage-focus.js';

require('./utils/Prototypes');
require('./utils/DispatchEvents');
require('./utils/WindowFunctions');

const Modules = {
	Hero: require('./modules/ModuleHero'),
	PopupGallery: require('./modules/ModulePopupGallery'),
	Popup: require('./modules/ModulePopup')
};

const Views = {
	Main: require('./views/View'),
	Pressroom: require('./views/ViewPressroom'),
};

window.basil = require('basil.js');

$(function () {
	initClasses($('#site'));
	ManageFocus();
});

window.initClasses = function (context) {
	_.each(context.find('[data-view]'), function (el) {
		const list = $(el).data('view').split(/\s+/);
		_.each(list, function (name) {
			if (Views[name] !== undefined) {
				// new Views[name]($(el)).init();
				const v = new Views[name].default($(el));
				v.init();
			} else {
				new Views.Main($(el)).init();
			}
		});
	});
	_.each(context.find('[data-module]'), function (el) {
		const list = $(el).data('module').split(/\s+/);
		_.each(list, function (name) {
			if (Modules[name] !== undefined) {
				const m = new Modules[name].default($(el));
				m.init();
			}
		});
	});
};
